/**
 * Renders a list of previous shares and a button to create a new share
 */

import React from 'react';
import { observer } from 'mobx-react';

// Config and routes
import { config } from '../../../config';
import { routes } from '../../../routes';

// Dependencies
import { formatDistanceToNow, isFuture } from 'date-fns';

// Icons
import * as icons from '../../ui/Icons';
import ShareVideo from "./ShareVideo";

const Shares = observer(class SessionDetails extends React.Component {
  /**
   * Confirm and then delete a share
   *
   * @function handleDelete
   * @param {string} shareSid
   */
  handleDelete = shareSid => {
    const {
      examSid,
      installSid,
      sessionSid,
      store,
      translation
    } = this.props;
    const { AppStore, PlayerStore } = store;

    const onConfirm = () => {
      const urlData = {
        examSid,
        installSid,
        sessionSid,
        shareSid
      };

      const callback = () => {
        AppStore.showToast(translation.delete_success, 'positive');
      }

      PlayerStore.deleteSessionShare(urlData, callback);
    }

    AppStore.showDialog({
      content: translation.delete_confirm,
      type: 'confirm',
      onConfirm
    });
  }
  handleShare = () => {
    const { examSid, installSid, sessionSid, store } = this.props;
    const { AppStore, PlayerStore, UserStore } = store;
    const { userSid } = UserStore.userData;

    const urlData = {
      examSid,
      installSid,
      sessionSid,
      userSid
    };

    const callback = () => {
      AppStore.showModal(
        { component: ShareVideo, props: {...this.props} },
        AppStore.translation.ShareVideo.heading
      );
    }

    PlayerStore.sharePlayback(urlData, callback);
  }

  render() {
    const { store, translation } = this.props;
    const { shares } = store.PlayerStore;
    const { sharedViewer } = store.AppStore;


    return (
      <section>
        <h2 className="meta">{translation.title}</h2>

        <div className="note">
          <p>{translation.share_instructions}</p>
          <p>{translation.share_details}</p>
        </div>

        {!sharedViewer &&
        <button
          className="btn btn--outline btn--full"
          onClick={this.handleShare}
        >
          <icons.share/>
          <span>{translation.share_button}</span>
        </button>
        }
        {shares.length > 0 &&
          <table className="table--list table--list-nowrap">
            <thead>
              <tr>
                <th scope="col">{translation.link}</th>
                <th scope="col">{translation.expires}</th>
                <th scope="col">{translation.delete}</th>
              </tr>
            </thead>

            <tbody>
              {shares.map(share =>
                <tr key={share.shareSid}>
                  <th
                    data-col={translation.link}
                    scope="row"
                  >
                    <a
                      href={`${config.domain}/${routes.authenticate}/${share.shareSid}`}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {share.shareSid}
                    </a>
                  </th>
                  <td data-col={translation.expires}>
                    {isFuture(new Date(parseInt(share.ttl, 10))) ?
                      formatDistanceToNow(new Date(parseInt(share.ttl, 10))) :
                      translation.expired
                    }
                  </td>
                  <td>
                    <button
                      className="btn--link btn--negative"
                      onClick={() => this.handleDelete(share.shareSid)}
                      type="button"
                    >
                      <icons.trash />
                      {translation.delete}
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        }
      </section>
    )
  }
})

export default Shares;